export default "__VITE_ASSET__kJIVTdqz__"